import { type TrackingContext, type TrackingEventMap, type TrackingEventName } from './types';

let context: TrackingContext = {
  enabled: false,
  page_type: '',
  page_title: '',
  page_name: '',
  analytics_page_type: 'other',
};

/** Initialize context from PHP-provided data. */
export function initContext(): void {
  const phpContext = window.InteractTrackingContext;
  if (phpContext) {
    context = { ...phpContext };
  }
}

/** Get the current page context. */
export function getContext(): TrackingContext {
  return context;
}

/** Push a structured event to the GTM dataLayer. */
export function track<E extends TrackingEventName>(event: E, params: TrackingEventMap[E]): void {
  if (!context.enabled) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...params,
  });
}

/** Expose the public API on window for React components. */
export function exposeGlobalAPI(): void {
  window.InteractTracking = { track, getContext };
}
